import React from 'react';
import DiagnosisHome from '../../../../components/Diagnosis/DiagnosisHome';

const Diagnosis = () => {
  const handleAddClick = () => {

  };

  return (
    <div>
      <DiagnosisHome onAddClick={handleAddClick} />
    </div>
  );
};

export default Diagnosis;
